import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import * as actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    permissionList: [],
    operationList: [], // 页面里面的对应的操作权限列表
    imgDomain: '', // 图片域名地址
    bucket_domain_token: '', //七牛上传token
    loginData: {}, //登录信息
    ossData: {
      accessKeyId: 'LTAI4GHvVDPPd26uMt5Uzrkh',
      accessKeySecret: 'qaVd4kMC8wRGTyjNGUAQ2ZGd51KIDC',
      endpoint: 'oss-cn-shenzhen.aliyuncs.com',
      bucket: 'gymoo-private',
      domain: 'https://gymoo-private.oss-cn-shenzhen.aliyuncs.com/'
    },
    fileType: [
      { type: '1', label: '图片' },
      { type: '2', label: '视频' },
      { type: '3', label: '文件' },
    ],
    fileClass: []
  },
  mutations,
  actions,
  plugins: [createPersistedState({ storage: window.sessionStorage })]
});

export default store;